import { Box, CircularProgress, Divider } from "@mui/joy";
import { Plus } from "lucide-react";
import { Link } from "react-router-dom";

import { DataGridSetting } from "../../../../components";
import { Button, Alert } from "../../../../shared";
import { useRoles } from "../../../../hooks/query";
import { useAuth } from "../../../../hooks";
import { IRole } from "../../../../interfaces";

import { columnDef } from "./column-def";
import { Breadcrumb } from "../Create/components";

export default function List() {
    const { selectedOrganization } = useAuth();
    const { useList } = useRoles();
    const { data, isLoading, isError, error } = useList();

    if (!selectedOrganization?.Id) {
        return (
            <Box flex={1} p={3}>
                <Alert errorMessage="Select an organization to view roles." />
            </Box>
        );
    }

    if (isLoading) {
        return (
            <Box flex={1} display="flex" justifyContent="center" alignItems="center">
                <CircularProgress />
            </Box>
        );
    }

    if (isError) {
        return (
            <Box flex={1} p={2}>
                <Box sx={{ color: "danger.plainColor" }}>
                    {error instanceof Error ? error.message : "Failed to load roles"}
                </Box>
            </Box>
        );
    }

    const roles = (data as IRole[]) || [];

    return (
        <Box flex={1} display={"flex"} flexDirection={"column"}>
            <Breadcrumb />
            <Divider />
            <Box flex={1}>
                <DataGridSetting
                    gridData={roles}
                    columnDefs={columnDef}
                    quickControlStartDecorator={<CreateRoleButton />}
                />
            </Box>
        </Box>
    );
}

function CreateRoleButton() {
    return (
        <Box display="flex" alignItems={"center"} ml={1.5}>
            <Button
                variant="soft"
                color="primary"
                component={Link}
                to="/admin/roles/new"
                startDecorator={<Plus size={18} />}
            >
                New Role
            </Button>
            <Divider orientation="vertical" sx={{ mt: 1, mb: 1, ml: 2 }} />
        </Box>
    );
}
